import React, { useEffect,useState, useRef } from 'react';
import { Select, TreeSelect } from 'antd';
import { SimulatorModel, SimulatorData } from '../models/SimulatorModel'
import { IDNameDescriptionItem, IDNameDescriptionDictionary, AutocompleteData, filterIDNameDescriptionDictionary } from '../models/Site'
const { TreeNode } = TreeSelect;

type Props = {
    IsBranchCanSelected:boolean;
    OnSelectStationUser:Function;
    OnSelectBranch:Function;
    SelectedStationUsrtId:string|null;
};

const BranchesStationsTree = (props: Props) => {
    const simulatorModel:SimulatorModel = new SimulatorModel();;

    const [allBranches, setAllBranches] = useState<any[]>([]);
    const [treeData, setTreeData] = useState<any[]>([]);
    const [treeDataForPopUp, setTreeDataForPopUp] = useState<any[]>([]);
    const [treeDataValue, setTreeDataValue] = useState<string | null>(null);
    const [users, setUsers] = useState<any[]>([]);
    


    useEffect(() => {
       

        load();
    }, []);


    
   const load = async ()=>{
    setTreeDataValue(props.SelectedStationUsrtId);
    await buildTreeSelectData();


   }

   const buildTreeSelectData = async() => {
    const allBranches = await simulatorModel.getBranchesAndUsers();
    
    setUsers(allBranches.users);
    const treeData: any[] = [];
    const treeDataForPopUp: any[] = [];
    if(props.IsBranchCanSelected){
    treeData.push(
      {
        value: '1',
        title: 'חדש',
        type: 'branchType'
      }
    );
    treeData.push(
      {
        value: '2',
        title: 'משומש',
        type: 'branchType'
      }
    );
    treeData.push(
      {
        value: '3',
        title: 'סלקט',
        type: 'branchType'
      }
    );
}
    const bTree = await getBranchesTree(allBranches.branches);
    bTree.forEach((bItem: any) => {
      // const users = allBranches.users.find((u: any) => u.id === bItem.branchManagerId);
      // console.log('buildTreeNode users', bItem.name, bItem.branchManagerId)
      const branch: any = {
        title: bItem.name,
        value: bItem.id,
        type: 'branchId',
        children: buildTreeNode(bItem.id, allBranches)
      }
      const branchforPopUp: any = {
        title: bItem.name,
        value: bItem.id,
        type: 'branchId',
        selectable: false,
        children: buildTreeNode(bItem.id, allBranches, true)
      }
      
      const rootBranchManager = allBranches.users.find((u: any) => u.id === bItem.branchManagerId);
      if (rootBranchManager) {
        if (!branch.children) {
          branch.children = [];
        }
        branch.children.push({
          title: rootBranchManager.fullName,
          value: rootBranchManager.id,
          type: 'stationUserId',
        })
        if (!branchforPopUp.children) {
          branchforPopUp.children = [];
        }
        branchforPopUp.children.push({
          title: rootBranchManager.fullName,
          value: rootBranchManager.id,
          type: 'stationUserId',
        })
      }
      treeData.push(branch);
      treeDataForPopUp.push(branchforPopUp)
    });
    
    setTreeData(treeData);
    setTreeDataForPopUp(treeDataForPopUp);
    setAllBranches(allBranches.branches);

 
  }

  const getBranchesTree = async (allBranches:any)=> {
  if(!allBranches){
      const branches = await simulatorModel.getBranchesAndUsers();
      const allBranches = branches.branches;
      
      
  }

    const branchesTree = allBranches.filter((b: any) => b.parentId === null);
    branchesTree.forEach((rootBranch: any) => {
        rootBranch.children = getSubBranches(rootBranch, allBranches);
    });

    console.log('branchesTree', branchesTree);

    return branchesTree;
}

const getSubBranches = (branch: any, branches: any[]) => {
    const subBranches = branches.filter((b: any) => b.parentId === branch.id);
    if (subBranches && subBranches.length > 0) {
        subBranches.forEach((b: any) => {
            b.children = getSubBranches(b, branches);
        })
    }
    return subBranches;
}

const arangeBranchesIntoTree = (bList: any[]) => {
    bList.forEach((branch: any, index: number) => {
        if (branch.parentId !== null) {
            const parentItem = bList.find((i: any) => i && i.id && i.id === branch.parentId);
            if (parentItem) {
                const child = JSON.parse(JSON.stringify(branch));
                if (parentItem.children) {
                    parentItem.children.push(child);
                } else {
                    parentItem.children = [child];
                }
            }
            delete bList[index];
        }
    })
}

const getTreeItem = (branch: any, isParent = true) => {
    if (branch.children) {
        isParent = true;
    }
    const item = {
        label: branch.name,
        value: branch.id,
        isParent: isParent ? true : false,
        // disabled: isParent ? true : false,
        className: 'hidden-checkbox',
        children: []
    }
    if (branch.children && branch.children.length > 0) {
        branch.children.forEach((c: any) => {
            const newItem = getTreeItem(c);
            item.children.push(newItem as never);
        })
    }
    return item;
}

const buildTreeNode =  (id: string, allBranches: any, forPopUp: boolean = false) =>{
    const rootBranch = allBranches.branches.find((b:any) => b.id === id);
    const children =  allBranches.branches.filter((b: any) => b.parentId === id);
    const nodeTree: any[] = []
    children.forEach((c: any) => {
      const branch: any = {
        title: c.name,
        value: c.id,
        selectable: !forPopUp,
        type: 'branchId',
        branchManagerId: c.branchManagerId
        // children: []
      }
      if (!branch.children) {
        branch.children = [];
      }
      branch.children = buildTreeNode(c.id, allBranches, forPopUp);
      if (c.users) {
        c.users.forEach((u: any) => {
          const user: any = {
            title: u.text,
            value: u.value,
            type: 'stationUserId',
          }
          branch.children.push(user);
        })
      }

      const branchUsers = allBranches.users.filter((u: any) => u.branchId === c.id);
      if (branchUsers && branchUsers.length > 0) {
        branchUsers.forEach((bUser: any) => {
          branch.children.push({
            title: bUser.fullName,
            value: bUser.id,
            type: 'stationUserId',
          })
        });
      }
      
      const branchManager = allBranches.users.find((u: any) => u.id === c.branchManagerId);
      if (branchManager) {
        if (!branch.children) {
          branch.children = [];
        }
        branch.children.push({
          title: branchManager.fullName,
          value: branchManager.id,
          type: 'stationUserId',
        })
      }
      nodeTree.push(branch);
    })
    return nodeTree;
  }

  const buildBranchesSelectData=async()=> {
    const branches = await getBranchesTree(null);
    let branchesSelectData: any[] = [];

    branches.forEach((b: any) => {
        const items = buildBranchSelectItems(b, '');
        branchesSelectData = Object.assign(branchesSelectData, items);
    });
    const newList = new IDNameDescriptionDictionary();
    const bList = buildSelectDataObject(branchesSelectData);
    newList['0'] = {
        description: 'עמדה',
        name: '',
        id: 0
    }
    bList.forEach((b, index) => {
        if (b && b.id) {
            newList[b.id] = b;
        }
    });
    console.log('newList', newList)
    return newList;
}

const buildBranchSelectItems = (branch: any, branchName: string = '') => {
    const b = {
        label: "VP Accounting",
        tagClassName: "special",
    }
    if (branchName !== '') {
        branchName += '/';
    }
    branchName += branch.name;
    let items: any[] = [];
    if (branch.users && branch.users.length > 0) {
        branch.users.forEach((user: any) => {
            items.push({
                value: user.value,
                text: branchName + '/' + user.text
            })
        })
    }
    if (branch.children && branch.children.length > 0) {
        branch.children.forEach((child: any) => {
            const childItems = buildBranchSelectItems(child, branchName);
            if (childItems && childItems.length > 0) {
                items = Object.assign(items, childItems);
            }
        })
    }

    return items;
}

const buildSelectDataObject = (dataList: any[]) => {
    return dataList.map((a: any) => {
        return {
            description: a.text,
            name: a.text,
            id: a.value
        }
    }) as IDNameDescriptionItem[];
}

const onHandlerChange =async (newValue: string, label: any, extra: any)=> { 
    
    
    switch (newValue) {
      case '1':
      case '2':
      case '3':
        break;
    
      default:
        var user =users.find((b: any) => b.id === newValue);
        const branch = allBranches.find((b: any) => b.id === newValue);
        if (user) {
            props.OnSelectStationUser(newValue);
        } else {

            setTimeout(()=>{
                setTreeDataValue(null);
            }, 100);
            
        }
        break;
    }
    
    const treeDataValue = label[0] ? label[0] : '';
    setTreeDataValue(treeDataValue);
    
  };


    return (
        <div>
            <TreeSelect
                                                  treeLine
                                                  placeholder={'עמדה'}
                                                  showSearch
                                                  style={{
                                                    width: '100%',
                                                  }}
                                                  dropdownStyle={{
                                                    maxHeight: 400,
                                                    overflow: 'auto',
                                                  }}
                                                  allowClear
                                                  value={treeDataValue ? treeDataValue : undefined  }
                                                  onChange={(v: string, l:any, e: any)=> onHandlerChange (v, l, e)}
                                                  treeData={treeData}
                                                />
        </div>



    );
};

//export default forwardRef<ChildRef, Props>(VehicleData);
export default BranchesStationsTree;